import { Navigate, generatePath } from 'react-router';

import { ROOT_PATH } from 'app/shared/consts';
import { useOpenParams } from 'app/shared/hooks/use-open-params';

export const AppRoot = (): JSX.Element => {
  const { buildingUuid } = useOpenParams();

  if (!buildingUuid) {
    return <Navigate to="/error" />;
  }

  const targetUrl = `${generatePath(ROOT_PATH, { ownerId: buildingUuid, ownerType: 'building' })}`;

  return <Navigate to={targetUrl} />;
};
